export const PRODUCT = 'ATLAS VISUEL DE NUTRITION VÉGÉTALE™'

export const PRODUCT_TAGLINE =
  'LE SYSTÈME COMPLET DE DIAGNOSTIC VISUEL, D’ANALYSE NUTRITIONNELLE ET DE SOLUTIONS PRATIQUES POUR LES CULTURES'

/** Anchor id of the €27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://atlas-nutrition-vegetale.impultienda.ar/checkout'

const RES =
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/9ea8e656-8de1-46d4-9ca5-2002a050ced7/'

/** Box-set mockup (hero, €27 offer and final CTA). */
export const MOCKUP_IMAGE = RES + '1793872099876_mockup-nutrition-f3213085.png'

export const RESOURCES_BASE = RES

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PRICE = '27 €'
export const COMPARE_PRICE = '97 €'

/** Meta Pixel ID — ATLAS VISUEL DE NUTRITION VÉGÉTALE (France), Pixel 4. */
export const PIXEL_ID = '2929031624140475'

export const METHOD = ['OBSERVER', 'COMPARER', 'INVESTIGUER', 'ANALYSER', 'ÉVALUER', 'AGIR']
export const METHOD_TEXT = METHOD.join(' › ')
